import ApiService from "@/common/api.service";

export const GeneralTimeService = {
  create(params) {
    return ApiService.post("general-times/add", params);
  },
  update(slug, params) {
    return ApiService.update("general-times", slug, params);
  },
  delete(slug, params) {
    return ApiService.delete("general-times", slug, params);
  },
};
